exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frame{flex-direction:column;overflow:hidden}.frame,.frame__content{display:flex;height:100%}.frame__content{flex:1;flex-direction:column;overflow:auto}", ""]);

// exports
